<template>
    <div id="dashboard">
        <div class="commonSearch" ref="commonSearchRef"><i class="fa fa-home"></i>首页demo （我会固定在最上面）</div>
        <div :style="pageContent" class="commonContent">
            <div>
                <div class="title">1- 推荐的常用方法</div>
                <p> 正常日志打印: this.$constant.info('我是log') 替换原来的 console.log </p>
                <p> 错误日志打印: this.$constant.error('我是error') 替换原来的 console.log</p>
                <p> (注:现在返回父页面无需回传参数即可在父页面获取之前传递的参数) 获取子页面返回的参数: let fromParam = this.$constant.GET_ROUTE_KEY(this) </p>
            </div>
            <div>
                <div class="title">2- 通用的上传组件</div>
                <div>
                    <div class="title2">我是单图片上传</div>
                    <FileUpload :typeId="1" :recordId="22" @single-img-data="singleImgData" :uploadType="uploadType" :fileId="fileId1"></FileUpload>
                    <div class="title2">我是多图片上传</div>
                    <FileUpload :typeId="1" :recordId="recordId2" @list-img-data="listImgData" :uploadType="uploadType2" :limitFileCount="2"></FileUpload>
                    <div class="title2">我是多文件拖拽上传</div>
                    <FileUpload :typeId="1" :recordId="25" @list-file-drag-data="listFileDragData" :uploadType="uploadType5"></FileUpload>
                    <video id="myVideo" class="video-js vjs-big-play-centered">
                        <source :src="loadFile2('ff80808171f77c9f0171f78f57390000')" type="video/mp4">
                    </video>
                </div>
            </div>
            <div>
                <div class="title">3- 列表的图片展示</div>
                <el-table :data="fileList" style="width: 100%" :show-header="false">
                    <el-table-column label="文件名" min-width="180">
                        <template slot-scope="scope">
                            <span style="margin-left: 10px">{{ scope.row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="250" align="center">
                        <template slot-scope="scope">
                            <img :src="loadImage(scope.row)" width="50" height="50" />
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div>
                <div class="title">4-echarts展示 </div>
                <div id="myChart" style="width: 600px;height:400px;"></div>
            </div>
        </div>
    </div>
</template>

<script>
// import FileUpload from "@/components/upload/FileUpload.vue";
import TabResize from "@/utils/TabResize.js";
export default {
    mixins: [TabResize],
    components: {
        // FileUpload
    },
    mounted () {
        this.drawColumn();
        this.initVideo();
    },
    data () {
        return {
            fileList: [
                {
                    id: '4028d8816d42dc76016d437419180008',
                    name: '我是文件A'
                },
                {
                    id: '4028d8816d42dc76016d437346c70006',
                    name: '我是文件B'
                }
            ],
            typeId: 1, //文件分类ID 一般为常量
            recordId: 2, //业务ID
            recordId2: "9002",
            uploadType: "single-img", //单图片
            uploadType2: "list-img", //多图片
            uploadType5: "list-file-drag", //多文件拖拽上传
            fileId1: "", //文件ID
            ruleForm: {
                name: ""
            },
            rules: {
                name: [
                    { required: true, message: "请输入param1内容", trigger: "blur" },
                    { min: 3, max: 10, message: "长度在 3 到 10 个字符", trigger: "blur" }
                ]
            }
        };
    },
    methods: {
        singleImgData (file) {
            this.$constant.info("我是单图片上传");
            this.$constant.info(file);
        },
        listImgData (file) {
            this.$constant.info("我是多图片上传");
            this.$constant.info(file);
        },
        listFileDragData (file) {
            this.$constant.info("我是多文件拖拽上传");
            this.$constant.info(file);
        },
        loadImage (file) {
            return this.$constant.LOAD_FILE(this, file.id);
        },
        loadFile (fileId) {
            return this.$constant.LOAD_FILE(this, fileId);
        },
        loadFile2 (fileId) {
            return process.env.VUE_APP_API + this.$constant.API_NSC + 'file/download/section/' + fileId;
        },
        onSub () {
            this.$router.push({
                name: "test",
                params: this.toParam
            });
        },
        submitForm (formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.toParam.param1 = this.ruleForm.name;
                } else {
                    this.$constant.LOG_ERROR('error submit!!');
                    return false;
                }
            });
        },
        resetForm (formName) {
            this.$refs[formName].resetFields();
            this.fromParam = {};
        },
        drawColumn () {
            let myChart = this.$echarts.init(document.getElementById('myChart'))
            let option = {
                title: {
                    text: 'ECharts示例'
                },
                tooltip: {},
                legend: {
                    data: ['销量']
                },
                xAxis: {
                    data: ["衬衫", "羊毛衫", "雪纺衫", "裤子", "高跟鞋", "袜子"]
                },
                yAxis: {},
                series: [{
                    name: '销量',
                    type: 'bar',
                    data: [5, 20, 36, 10, 10, 20]
                }]
            };
            myChart.setOption(option);
        },
        initVideo () {
            let myPlayer = this.$video(myVideo, {
                //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
                controls: true,
                //自动播放属性,muted:静音播放
                autoplay: false,
                //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
                preload: "auto",
                //设置视频播放器的显示宽度（以像素为单位）
                width: "500px",
                //设置视频播放器的显示高度（以像素为单位）
                height: "400px"
            });
        }
    }
};
</script>

<style lang="stylus" scoped>
#dashboard {
    .commonSearch {
        font-size: $default-font;
    }

    p {
        margin-left: 30px;
        font-size: $default-font;
    }

    p, div {
        padding: 10px;
    }

    .title {
        color: $theme-color;
        font-size: $default-font;
        font-weight: bold;
    }

    .title2 {
        font-size: $default-font;
    }
}
</style>

